// src/features/business-functions/constants/workspaceConstants.js

/** @deprecated Legacy section tabs — workspace detail now uses one tab per table. */
export const WORKSPACE_TAB_CONFIG = [];

export const DEFAULT_WORKSPACE_TAB = null;

export const WORKSPACE_STATUS = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
};
